(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7300],{

/***/ 90359:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[id]",
      function () {
        return __webpack_require__(19436);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46099);
/* harmony import */ var _feat_components_Category__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18267);
/* harmony import */ var _components_AppLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80330);
/* harmony import */ var _store_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22972);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var CategoryMain = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    /**
   * SEO-354: 브레드크럼의 UI(<a href>) 와 BreadcrumbList 스키마가
   * 같은 배열(trail) 하나에서 파생되도록 SSR 에서 계층을 확정한다.
   */ var hub = (0,_store_common__WEBPACK_IMPORTED_MODULE_5__/* .resolveCategoryHub */ .dw)(props === null || props === void 0 ? void 0 : props.section);
    var trail = (0,_store_common__WEBPACK_IMPORTED_MODULE_5__/* .buildBreadcrumbTrail */ .FL)({
        hub: hub,
        hubName: props === null || props === void 0 ? void 0 : props.breadcrumbHubName,
        categories: props === null || props === void 0 ? void 0 : props.breadcrumbCategories
    });
    var pageLabelMeta = [
        {
            property: "section",
            content: (props === null || props === void 0 ? void 0 : (ref = props.pageLabelMeta) === null || ref === void 0 ? void 0 : ref.section) === "MALL" ? "HF" : "RH" || 0
        },
        {
            property: "category1_name",
            content: (props === null || props === void 0 ? void 0 : (ref1 = props.pageLabelMeta) === null || ref1 === void 0 ? void 0 : ref1.category1_name) || ""
        },
        {
            property: "category2_name",
            content: (props === null || props === void 0 ? void 0 : (ref2 = props.pageLabelMeta) === null || ref2 === void 0 ? void 0 : ref2.category2_name) || ""
        },
        {
            property: "category3_name",
            content: (props === null || props === void 0 ? void 0 : (ref3 = props.pageLabelMeta) === null || ref3 === void 0 ? void 0 : ref3.category3_name) || ""
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                noindex: "production" !== "production",
                nofollow: "production" !== "production",
                title: props === null || props === void 0 ? void 0 : (ref4 = props.pageLabelMeta) === null || ref4 === void 0 ? void 0 : ref4.title,
                description: props === null || props === void 0 ? void 0 : (ref5 = props.pageLabelMeta) === null || ref5 === void 0 ? void 0 : ref5.category_description,
                openGraph: {
                    description: props === null || props === void 0 ? void 0 : (ref6 = props.pageLabelMeta) === null || ref6 === void 0 ? void 0 : ref6.category_description
                },
                additionalMetaTags: [
                    {
                        name: "viewport",
                        content: "width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0"
                    }, 
                ].concat(_toConsumableArray(pageLabelMeta))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .BreadcrumbJsonLd */ .gR, {
                useAppDir: true,
                itemListElements: (0,_store_common__WEBPACK_IMPORTED_MODULE_5__/* .buildBreadcrumbJsonLd */ .yf)({
                    baseUrl: "https://store.hanssem.com" || 0,
                    trail: trail
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AppLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                infoState: true,
                channel: props === null || props === void 0 ? void 0 : (ref7 = props.pageLabelMeta) === null || ref7 === void 0 ? void 0 : ref7.section,
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feat_components_Category__WEBPACK_IMPORTED_MODULE_3__/* .Category */ .W, _objectSpreadProps(_objectSpread({}, props), {
                    trail: trail
                }))
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CategoryMain);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2741,330,1764,8267,9774,2888,179], function() { return __webpack_exec__(90359); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);